import { useTranslation } from '@/i18n'

/** Thinking indicator — matches Figma ReasoningTrigger: logo + shimmer text */
const LoadingMessage = () => {
  const { t } = useTranslation()
  return (
    <div className="flex justify-start py-2">
      <div className="flex items-center gap-2">
        <img
          src="/images/intuai-logo-icon.svg"
          alt=""
          className="w-4 h-4 flex-shrink-0"
          aria-hidden="true"
        />
        <span className="text-sm font-medium thinking-shimmer">
          {t('chat:messages.thinking', { defaultValue: 'Thinking' })}
        </span>
      </div>
    </div>
  )
}

export default LoadingMessage;
